// Copied and modified from useHooks library.
// https://github.com/uidotdev/usehooks/blob/main/index.js
import { useLayoutEffect } from 'react';
const useLockBodyScrollEffect = ({ isLocked = true, }) => {
    useLayoutEffect(() => {
        if (isLocked) {
            const originalOverflow = (window
                .getComputedStyle(document.body)
                .overflow);
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = originalOverflow;
            };
        }
        return () => { };
    }, [
        isLocked,
    ]);
};
export { useLockBodyScrollEffect };
